// go(path): client-side navigation outside components (wouter listens to
// pushState); the demo's go() for hash routes, on real paths.
export function go(path: string) {
  history.pushState(null, "", path);
  dispatchEvent(new PopStateEvent("popstate"));
}
